module.exports = __webpack_public_path__ + "img/transport_motorcycle.46b06b3.png";